import React from 'react'
import {
  Grid, Card, CardContent, CardMedia, Typography,
} from '@material-ui/core/'
import ReadMoreReact from 'read-more-react'
import moment from 'moment'
import nature from '../../../assetss/img/nature.jpeg'
import { useStyles } from './styles'

const MediaCard = ({ data, goTo }) => {
  const classes = useStyles()

  return (
    <Card className={classes.root}>
      <CardMedia
        onClick={() => goTo(data)}
        className={classes.media}
        image={data?.image?.src || nature}
      />
      <CardContent>
        <div onClick={() => goTo(data)} className={classes.clickContainer}>
          <Typography
            className={classes.cardTitle}
            gutterBottom
            variant='h5'
            component='h2'
          >
            {data?.title}
          </Typography>
          {data?.text && (
            <Typography component='span' className={classes.subDescriptions} variant='body1' color='textSecondary'>
              <ReadMoreReact
                min={75}
                max={100}
                ideal={77}
                text={data?.text}
                readMoreText='... read more'
              />
            </Typography>
          )}
        </div>
        <div className={classes.hashtegBox}>
          {data?.hashtags?.[0]?.split(' ')?.map((i, ind) => (
            <Typography key={ind} className='hashteg'>
              {i}
            </Typography>
          ))}
        </div>
        <Grid container alignItems='flex-end' justify='space-between'>
          <Typography variant='body2' className={classes.dataAdress}>
            Posted on {moment(+data?.createdAt)?.format('MMMM, D, h:mm A')}<br />
            {+data?.type === 0 ? 'by someone who need help' : 'by someone who cares'} {data?.author?.town && `from ${data?.author?.town}`}
          </Typography>
          <Typography className={classes.status}>
            {data?.author?.isOnline && 'online'}
          </Typography>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default MediaCard
